// extracted by mini-css-extract-plugin
module.exports = {"refreshHint":"CloudinaryConfig_refreshHint__NZw0W"};